import InputEntity from '@/lib/formFactory/inputEntity';
import SelectEntity from "@/lib/formFactory/select/entity";
import ImageEntity from "@/lib/formFactory/imageEntity";

export default class EntityModel {
    model: any;

    constructor() {
        const title = new InputEntity('title');
        title.setTitle('Название');
        title.setRequired(true);

        const type = new SelectEntity('type')
            .setTitle('Тип')
            .setRequired(true)

        const activeIcon = new ImageEntity('activeIcon');
        activeIcon.setTitle('Активная иконка');
        activeIcon.setKey('active-icon-input');

        const defaultIcon = new ImageEntity('defaultIcon');
        defaultIcon.setTitle('Иконка');
        defaultIcon.setKey('default-icon-input');

        this.model = {
            title: title.entity[title.entityName],
            type: type.entity,
            activeIcon: activeIcon.entity[activeIcon.entityName],
            defaultIcon: defaultIcon.entity[defaultIcon.entityName],
        };
    }
}
